import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { addTrailingSlash } from '@backmarket/utils/url/addTrailingSlash'
import { removeLeadingSlash } from '@backmarket/utils/url/removeLeadingSlash'

import type { TrackingConfig } from '../types'

function toPublicPath(path: string, cdnURL?: string) {
  return cdnURL
    ? new URL(removeLeadingSlash(path), addTrailingSlash(cdnURL)).href
    : path
}

export type DidomiConfig = {
  user: {
    bots?: {
      consentRequired: boolean
    }
    country?: string
    region?: string
  }
  cookies: {
    storageSources: {
      cookies: boolean
      localStorage: boolean
    }
  }
  app: {
    logoUrl: string
  }

  notice: {
    learnMorePosition: 'after' | 'before'
    textAlignment: 'left' | 'center' | 'right'
    enable: boolean
  }
  languages: {
    enabled: string[]
    default: string
  }
}

export const getDidomiConfig = ({
  config,
  countryCode,
  cdnURL,
  language,
}: {
  config: TrackingConfig
  countryCode: MarketCountryCode
  cdnURL?: string
  language: string
}): DidomiConfig => {
  return {
    user: { bots: { consentRequired: false } },
    cookies: {
      storageSources: {
        cookies: true,
        localStorage: false,
      },
    },
    app: {
      logoUrl: toPublicPath('/img/legal/cookies.png', cdnURL),
    },
    notice: {
      learnMorePosition: 'after',
      textAlignment: 'center',
      enable: !config.countriesWithNoCookieOptIn.includes(countryCode),
    },
    // see https://support.didomi.io/how-to-force-the-language-of-my-banner-with-the-language-of-my-website
    languages: {
      enabled: [language],
      default: language,
    },
  }
}

export const VENDORS_ID = {
  amplitude: 'amplitude-nzaqxfRQ',
  braze: 'braze-x4LHJX93',
  gtm: 'googletag-Et9AC4np',
  appsFlyer: 'appsflyer-Gi8QYXZh',
  youtube: 'youtube-7yXhnFRP',
} as const

export const VENDORS_SDK_ID = {
  youtube: 'c:youtube-7yXhnFRP',
}

export const DIDOMI_COOKIE_NAME = 'euconsent-v2'
